import React from "react";

import type { BoxProps } from "@/ui/atoms/Box";

export type DragDropPreventerProps = Pick<BoxProps, "children">;

const DragDropPreventer = (props: DragDropPreventerProps) => {
    const { children } = props;

    React.useEffect(() => {
        const preventDefaultDragOver = (event: DragEvent) => {
            event.preventDefault();
            event.stopImmediatePropagation();
        };

        const preventDefaultDrop = (event: DragEvent) => {
            event.preventDefault();
            event.stopImmediatePropagation();
        };

        document.addEventListener("dragover", preventDefaultDragOver);
        document.addEventListener("drop", preventDefaultDrop);

        return () => {
            document.removeEventListener("dragover", preventDefaultDragOver);
            document.removeEventListener("drop", preventDefaultDrop);
        };
    }, []);

    return children;
};

export default DragDropPreventer;

DragDropPreventer;
